import { ofType } from "redux-observable";
import { notifyError, notifyWarning, sendApiRequest } from "../../../actions";
import generateError from "../../../utilities/generateError";
import {
  getAllScoreCardsRiskFactorsByTypeFulfilled,
  getAllScoreCardsRiskFactorsByTypePending,
  getAllScoreCardsRiskFactorsByTypeRejected,
} from "../actions/getAllScoreCardsRiskFactorsByType";
import { GET_ALL_SCORE_CARDS_RISK_FACTORS_BY_TYPE } from "../types/getAllScoreCardRiskFactorsByType";
import { debounceTime, mergeMap } from "rxjs/operators";
import { merge, of } from "rxjs";

const getAllScoreCardsRiskFactorsByTypePayload = (payload) => ({
  method: "get",
  url: "scorecard/getallscorecardriskfactorsbytype",
  onSuccess: [
    (response) =>
      response.data.length === 0
        ? notifyWarning("Something went wrong with getting all score cards")
        : getAllScoreCardsRiskFactorsByTypeFulfilled(response),
  ],
  onError: [
    getAllScoreCardsRiskFactorsByTypeRejected,
    (error) => notifyError(generateError(error)),
  ],
  data: payload,
});

const meta = {
  api: "ajaxApi",
};

const getAllScoreCardRiskFactorsByTypeEpic$ = (action$) =>
  action$.pipe(
    ofType(GET_ALL_SCORE_CARDS_RISK_FACTORS_BY_TYPE.DEFAULT),
    debounceTime(500),
    mergeMap(() =>
      merge(
        of(getAllScoreCardsRiskFactorsByTypePending()),
        of(sendApiRequest(getAllScoreCardsRiskFactorsByTypePayload({}), meta))
      )
    )
  );

export default getAllScoreCardRiskFactorsByTypeEpic$;



// WEBPACK FOOTER //
// ./src/features/score-card/epics/getAllScoreCardRiskFactorsByType.js